<template>
  <div class="box1">
    
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  width: 100%;
  height: 1010px;
  background: url("../../../assets/coursePage/harmony/box1/banner.png") no-repeat;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
}
</style>
